import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { Container, Box, Typography, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { checkImpersonateToken } from 'services/api';

const Impersonate = () => {
    const history = useHistory();
    const { token } = useParams();
    const { t } = useTranslation();

    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setMessage(t('Validation...'));

        const fetchData = async () => {
            try {
                const formData = new FormData();
                formData.append('token', token);

                const response = await checkImpersonateToken(formData);

                if (response.success && response.token) {
                    localStorage.setItem('token', response.token);
                    setMessage(t('Vous allez être redirigé'));

                    setTimeout(() => {
                        history.push('/');
                    }, 800);
                } else {
                    setMessage(response.message || t('Token invalide'));
                }
            } catch (err) {
                console.error('Impersonate error:', err);
                setMessage(t('Erreur inattendue'));
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [token, history, t]);

    return (
        <Container>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="100vh"
                textAlign="center"
            >
                <Box mb={3}>
                    <Link to="/login">
                        <img src="/img/logo.svg" alt="logo" />
                    </Link>
                </Box>

                <Typography variant="h4" component="h1" mt={2} mb={5}>
                    Maintenance
                </Typography>

                {loading && <CircularProgress sx={{ mb: 2 }} />}

                <Typography variant="body1">
                    {message}
                </Typography>
            </Box>
        </Container>
    );
};

export default Impersonate;